import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  PaginateQuery,
  CreateGovernorateRequest,
  UpdateGovernorateRequest,
} from "../../interfaces";

export const governorateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGovernorates: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/governorate"),
      }),
      providesTags: ["Paginated-Governorates"],
    }),
    getGovernorate: builder.query<any, string>({
      query: (id) => ({ url: `/api/governorate/${id}` }),
      providesTags: ["Governorate"],
    }),
    getGovernorateSelectList: builder.query<any, void>({
      query: () => ({ url: `/api/governorate/select-list/all` }),
      providesTags: ["Governorate-Select-List"],
    }),
    addGovernorate: builder.mutation<any, CreateGovernorateRequest>({
      query: (data) => ({
        url: "/api/governorate",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Governorate",
        "Governorate-Select-List",
        "Paginated-Governorates",
      ],
    }),
    updateGovernorate: builder.mutation<
      any,
      { id: string; data: UpdateGovernorateRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/governorate/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "Governorate",
        "Governorate-Select-List",
        "Paginated-Governorates",
      ],
    }),
    deleteGovernorate: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/governorate/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Governorate-Select-List", "Paginated-Governorates"],
    }),
  }),
});

export const {
  useGetGovernoratesQuery,
  useGetGovernorateQuery,
  useGetGovernorateSelectListQuery,
  useAddGovernorateMutation,
  useUpdateGovernorateMutation,
  useDeleteGovernorateMutation,
} = governorateApi;
